<template>
    <div class="logo">
        <h1 class="text-center mb-5">{{ mensagem }}</h1>

        <DialogCommercialHierarchyLogin v-model="dialogCommercialHierarchyVisible" :items="commercialHierarchyData" :show-close-button="false" />
        <DialogCommercialHierarchyAssistentLogin v-model="dialogAssistentCommercialHierarchyVisible" :items="commercialHierarchyAssistentData" @validateHierarchyReturn="validateHierarchyReturn" />
    </div>
</template>

<script>

  import { flavorRes, loadFlavor } from '../plugins/flavors'
  import { autenticarNewConEscritorio2 } from '../webservice/autenticar'
  import { alert, findUnidadeMultiplasEmpresas, notification } from '../plugins/helpers'
  import { origensAcesso } from '@/plugins/constants'
  import DialogCommercialHierarchyLogin from '@/components/hierarquia-comercial/DialogCommercialHierarchyLogin.vue'
  import commercialHierarchy from '@/mixins/commercialHierarchy'
  import DialogCommercialHierarchyAssistentLogin from '@/components/hierarquia-comercial/DialogCommercialHierarchyAssistentLogin.vue'
  import { AlertTypes } from '../plugins/alerts_types'

  export default {
    name: 'LoginExternoEscritoriov2',
    components: { DialogCommercialHierarchyAssistentLogin, DialogCommercialHierarchyLogin },
    mixins: [commercialHierarchy],
    data: () => ({
      mensagem: 'Autenticando...',
      logo: ''
    }),
    mounted () {
      this.$session.destroy()
      loadFlavor('rodobens')
      this.logo = flavorRes('img/logo-menu.png')

      const params = this.$route.query

      autenticarNewConEscritorio2(params.token, params.cdSimulacao, params.id_visual, params.id_empresa)
        .then(async (res) => {
          if (res.data.simulacao) {
            this.$session.set('simulacao', res.data.simulacao)
          }

          if (res.data.cd_simulacao) {
            this.$session.set('cd_simulacao', res.data.cd_simulacao)
          }

          if (res.data.id_visual) {
            this.$session.set('id_visual', res.data.id_visual)
          }

          if (res.data.id_empresa) {
            this.$session.set('id_empresa_ed', res.data.id_empresa)
          }

          if (res.data.login) {
            this.$session.set('login', res.data.login)
          }

          let ambientesPorUsuario = await this.$http.post('/ambientes-por-usuario', {
            data: res.data,
            empresas: res.data.Empresas
          }).then(res => {
            return res.data
          })
          return { res, ambientesPorUsuario }
        })
        .catch(err => {
          this.$session.destroy()
          notification(AlertTypes.ERROR, err, 'Não foi possível realizar o login!', true)
        })
        .then(async ({ res, ambientesPorUsuario }) => {
          if (this.validateHierarchyReturn(res)) {
            return
          }
          this.$session.set('origem_acesso', origensAcesso.sso)
          const empresas = res.data.Empresas.Empresa
          const unidades = res.data.UnidadesNegocio
          const id_empresa = this.$session.get('id_empresa')
          const id_unidade = this.$session.get('id_unidade_negocio')

          const ids_empresas_permitidas_usuario = empresas.map(empresa => empresa.ID_Empresa)
          const ids_empresas_permitidas_ambiente = ambientesPorUsuario.empresas_permitidas.map(empresa => empresa.ID_Empresa)

          let id_representante = null

          if (empresas) {
            this.$session.set('id_empresa', id_empresa)
            this.$session.set('empresas', empresas)

            const filial = res.data['FiliaisVenda']['FilialVenda'].find(filial => filial.ID_Empresa === id_empresa)

            if (filial) {
              this.$session.set('filial', filial)
            }
          } else {
            alert(`A empresa ${id_empresa} é inválida. Consulte a administradora`)
            return
          }

          if (id_representante && id_representante.length > 30) {
            notification('warning', 'Identificador do representante inválido.')
            return
          }
          const unidade = findUnidadeMultiplasEmpresas(id_unidade, unidades, ids_empresas_permitidas_usuario, this.$session.get('vendas_backoffice'))
          if (unidade) {
            this.$session.set('id_unidade_negocio', id_unidade)
            this.$session.set('unidades', [unidade])
          } else {
            alert(`A Unidade de Negócio ${id_unidade} é inválida. Consulte a administradora`)
            return
          }
          this.$session.set('identificador_representante_tribanco', id_representante)
          this.$session.set('ids_empresas_permitidas', ids_empresas_permitidas_ambiente)

          this.$session.set('unidade_exclusiva', ambientesPorUsuario.unidade_negocio_exclusiva)

          // Verificar se é simulação com ambiente pré-selecionado
          const isSimulacao = this.$session.get('simulacao') === true || this.$session.get('simulacao') === 'true'
          const idVisualRecebido = this.$session.get('id_visual')
          const idEmpresaRecebido = this.$session.get('id_empresa_ed')

          if (isSimulacao && idVisualRecebido && idEmpresaRecebido) {
            // Fluxo de simulação: carregar ambientes e selecionar automaticamente
            await this.carregarAmbientesESelecionar(ids_empresas_permitidas_ambiente, id_unidade, idVisualRecebido, idEmpresaRecebido)
          } else {
            // Fluxo normal: redirecionar para escolha de ambiente
            if (res.data.vendas_backoffice) {
              this.$router.replace('/')
            } else {
              this.$router.replace('/escolher_ambiente')
            }
          }
        })
    },
    methods: {
      async carregarAmbientesESelecionar (ids_empresas_permitidas_ambiente, cd_unidade_exclusiva, idVisual, idEmpresa) {
        try {
          const ambientes = await this.$http
            .post('/ambientes', {
              ids_empresas: ids_empresas_permitidas_ambiente,
              cd_unidade_exclusiva
            })
            .then(res => res.data)

          // Encontrar o ambiente que corresponde ao id_visual e id_empresa
          const ambienteEncontrado = ambientes.find(amb =>
            amb.id_visual === idVisual && amb.id_empresa_newcon === idEmpresa
          )

          if (!ambienteEncontrado) {
            notification(AlertTypes.ERROR, `Ambiente com id_visual=${idVisual} e id_empresa=${idEmpresa} não encontrado.`, 'Erro na simulação!')
            this.$router.replace('/escolher_ambiente')
            return
          }

          if (ambienteEncontrado) {
            const mapaCondicoes = this.$session.get('unidades_condicoes_venda') || {}
            const condicaoAmbiente = ambienteEncontrado.unidade_condicoes_venda || null
            const condicaoUsuario = mapaCondicoes[ambienteEncontrado.id_visual] || null

            const podeAtivar = condicaoAmbiente === null || condicaoAmbiente.toString() === condicaoUsuario?.toString()

            if (!podeAtivar) {
              notification(AlertTypes.ERROR, 'Caro parceiro, seu usuário não está liberado para esse ambiente, por favor, entre em contato com a Área de Suporte!')
              return
            }
          }

          // Montar o payload e redirecionar para o ambiente
          this.enviarParaAmbienteComAutocomplete(ambienteEncontrado)
        } catch (error) {
          console.error('Erro ao carregar ambientes para simulação:', error)
          notification(AlertTypes.ERROR, error.message, 'Erro na simulação!')
          this.$router.replace('/escolher_ambiente')
        }
      },
      enviarParaAmbienteComAutocomplete (ambiente) {
        const payload = this.pegarPayloadDeLogin()

        const urlBase = ambiente.url === 'localhost:8080'
          ? 'http://' + ambiente.url
          : 'https://' + ambiente.url

        const url = urlBase + '/Sistema/#/setar_ambiente_ssov2?ambiente=' +
          btoa(JSON.stringify(ambiente)) +
          '&dados_usuario=' +
          btoa(JSON.stringify(payload))

        window.open(url, '_self')
      },
      pegarPayloadDeLogin () {
        const id_usuario = this.$session.get('id_usuario')
        const login = this.$session.get('login')
        const nome = this.$session.get('nome')
        const token = this.$session.get('token')
        const empresas = this.$session.get('empresas')
        const unidades = this.$session.get('unidades')
        const id_comissionado = this.$session.get('id_comissionado')
        const filiais = this.$session.get('filiais')
        const id_ponto_venda = this.$session.get('id_ponto_venda')
        const id_unidade_negocio = this.$session.get('id_unidade_negocio')
        const admin = this.$session.get('admin')
        const exibe_politica_vendas = this.$session.get('exibe_politica_vendas')
        const limite_cotas_para_reservar_ativo = this.$session.get('limite_cotas_para_reservar_ativo')
        const quantidade_cotas_reservar = this.$session.get('quantidade_cotas_reservar')
        const percentual_cotas_disponiveis_ativo = this.$session.get('percentual_cotas_disponiveis_ativo')
        const percentual_cotas_disponiveis = this.$session.get('percentual_cotas_disponiveis')
        const procura_cidade_por_id = this.$session.get('procura_cidade_por_id')
        const exibe_contratos_painel = this.$session.get('exibe_contratos_painel')
        const exibe_contratos_sistema = this.$session.get('exibe_contratos_sistema')
        const exibe_reenvio_whatsapp = this.$session.get('exibe_reenvio_whatsapp')
        const permite_logar_tela_login = this.$session.get('permite_logar_tela_login')
        const permite_multiplicar_cota = this.$session.get('permite_multiplicar_cota')
        const exibe_reenvio_email = this.$session.get('exibe_reenvio_email')
        const id_usuario_interno = this.$session.get('id_usuario_interno')
        const produtos = this.$session.get('produtos')
        const origemAcesso = this.$session.get('origem_acesso')
        const vendas_backoffice = this.$session.get('vendas_backoffice')
        const filial = this.$session.get('filial')
        const identificador_representante_tribanco = this.$session.get('identificador_representante_tribanco')
        const ids_empresas_permitidas = this.$session.get('ids_empresas_permitidas')
        const unidade_exclusiva = this.$session.get('unidade_exclusiva')
        const tempo_alertas_erro = this.$session.get('tempo_alertas_erro')
        const tempo_alertas_variados = this.$session.get('tempo_alertas_variados')
        const unidades_condicoes_venda = this.$session.get('unidades_condicoes_venda')
        const broker_fluxo_vendas_comum = this.$session.get('broker_fluxo_vendas_comum')
        const broker_politica_vendas = this.$session.get('broker_politica_vendas')
        const cd_simulacao = this.$session.get('cd_simulacao')
        const simulacao = this.$session.get('simulacao')
        const id_visual = this.$session.get('id_visual')
        const id_empresa_ed = this.$session.get('id_empresa_ed')

        return {
          id_usuario,
          login,
          nome,
          token,
          empresas,
          unidades,
          id_comissionado,
          filiais,
          id_ponto_venda,
          id_unidade_negocio,
          admin,
          exibe_politica_vendas,
          limite_cotas_para_reservar_ativo,
          percentual_cotas_disponiveis_ativo,
          percentual_cotas_disponiveis,
          quantidade_cotas_reservar,
          procura_cidade_por_id,
          exibe_contratos_painel,
          exibe_contratos_sistema,
          exibe_reenvio_whatsapp,
          exibe_reenvio_email,
          permite_logar_tela_login,
          permite_multiplicar_cota,
          id_usuario_interno,
          produtos,
          vendas_backoffice,
          filial,
          identificador_representante_tribanco,
          ids_empresas_permitidas,
          unidade_exclusiva,
          origemAcesso,
          tempo_alertas_erro,
          tempo_alertas_variados,
          unidades_condicoes_venda,
          broker_fluxo_vendas_comum,
          broker_politica_vendas,
          cd_simulacao,
          simulacao,
          id_visual,
          id_empresa_ed
        }
      }
    }
  }
</script>

<style scoped>
    .logo {
        width: 100%;
        margin-top: 15px;
    }

    .logo img {
        margin: auto;
        display: block;
    }
</style>
